import { render } from "./alert.vue?vue&type=template&id=45bc4175"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
script.render = render

export default script